import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = {
    class: "offcanvas offcanvas-start mobile-menu",
    tabindex: "-1",
    ref: "_MobileMenu",
    id: "offcanvasRight",
    "aria-labelledby": "offcanvasRightLabel"
};
const _hoisted_2 = { class: "offcanvas-header header-container p-0" };
const _hoisted_3 = { class: "header" };
const _hoisted_4 = { class: "header-text" };
const _hoisted_5 = { class: "offcanvas-body p-0" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_navview_item = _resolveComponent("g-navview-item");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", null, [
                    (!_ctx.isTop)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: _cache[0] || (_cache[0] = _withModifiers(
                            //@ts-ignore
                            (...args) => (_ctx.onMoveBack && _ctx.onMoveBack(...args)), ["prevent"])),
                            class: "icon-button",
                            type: "button"
                        }, [...(_cache[2] || (_cache[2] = [
                                _createElementVNode("span", { class: "wrapper" }, [
                                    _createElementVNode("svg", {
                                        class: "icon",
                                        focusable: "false",
                                        fill: "currentColor",
                                        viewBox: "0 0 24 24",
                                        role: "img",
                                        "aria-hidden": "false"
                                    }, [
                                        _createElementVNode("path", { d: "M22.807 11.25H1.938l7.72-7.72a.75.75 0 0 0-1.06-1.06l-7.94 7.94a2.252 2.252 0 0 0 0 3.18l7.94 7.94a.747.747 0 0 0 1.06 0 .75.75 0 0 0 0-1.06l-7.72-7.72h20.87a.75.75 0 0 0 0-1.5z" })
                                    ])
                                ], -1)
                            ]))]))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.label), 1),
                _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] =
                        //@ts-ignore
                        (...args) => (_ctx.onToogle && _ctx.onToogle(...args))),
                    class: "icon-button",
                    type: "button"
                }, [...(_cache[3] || (_cache[3] = [
                        _createElementVNode("span", { class: "wrapper" }, [
                            _createElementVNode("svg", {
                                class: "icon",
                                focusable: "false",
                                fill: "currentColor",
                                viewBox: "0 0 24 24",
                                role: "img",
                                "aria-hidden": "false"
                            }, [
                                _createElementVNode("path", { d: "m13.057 11.996 7.723-7.723a.75.75 0 1 0-1.06-1.06l-7.724 7.723-7.723-7.724a.75.75 0 1 0-1.06 1.061l7.723 7.723-7.716 7.717a.75.75 0 1 0 1.06 1.06l7.716-7.716 7.717 7.716a.747.747 0 0 0 1.06 0 .75.75 0 0 0 0-1.06l-7.716-7.717z" })
                            ])
                        ], -1)
                    ]))])
            ])
        ]),
        _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nodes, (node) => {
                return (_openBlock(), _createBlock(_component_g_navview_item, {
                    level: 1,
                    label: node.caption,
                    "data-item": node,
                    "move-to": _ctx.onMoveToItem,
                    "has-children": _ctx.hasChildren
                }, null, 8, ["label", "data-item", "move-to", "has-children"]));
            }), 256))
        ]),
        _renderSlot(_ctx.$slots, "default")
    ], 512));
}
